import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

export const CtaFootnoteSantander = ({isFooterCentered = false}) => {
  const {domain, i18n} = useContext(Context)

  const URL_STATICS_IMAGES = domain.get('config').get('URL_STATICS_IMAGES')
  const logoSantander = `${URL_STATICS_IMAGES}common/logos/santander.svg`

  const ctaFooterClassname = cx('mt-ModalTransactionDiscover-ctaFootnote', {
    'mt-ModalTransactionDiscover-ctaFootnote--centered': isFooterCentered
  })

  return (
    <div className={ctaFooterClassname}>
      <div className="mt-ModalTransactionDiscover-ctaFootnoteText">{i18n.t('COMMON.PAYCAR_SERVICE_OFFERED_BY')}</div>
      <div className="mt-ModalTransactionDiscover-ctaFootnoteLogoWrapper">
        <AtomImage src={logoSantander} alt="santander logo" className="mt-ModalTransactionDiscover-ctaFootnoteLogo" />
      </div>
    </div>
  )
}

export const CtaFootnoteSantanderDGT = ({isFooterCentered = false}) => {
  const {domain, i18n} = useContext(Context)

  const URL_STATICS_IMAGES = domain.get('config').get('URL_STATICS_IMAGES')
  const logoSantander = `${URL_STATICS_IMAGES}common/logos/santander.svg`

  const ctaFooterClassname = cx('mt-ModalTransactionDiscover-ctaFootnote', {
    'mt-ModalTransactionDiscover-ctaFootnote--centered': isFooterCentered
  })

  return (
    <div className={ctaFooterClassname}>
      <div className="mt-ModalTransactionDiscover-ctaFootnoteText">{i18n.t('COMMON.PAYCAR_SERVICE_OFFERED_BY')}</div>
      <div className="mt-ModalTransactionDiscover-ctaFootnoteLogoWrapper">
        <div>
          <AtomImage src={logoSantander} alt="santander logo" className="mt-ModalTransactionDiscover-ctaFootnoteLogo" />
        </div>
      </div>
    </div>
  )
}

export const CtaFootnoteRapidPayLogalty = ({isFooterCentered = false}) => {
  const {domain, i18n} = useContext(Context)

  const URL_STATICS_IMAGES = domain.get('config').get('URL_STATICS_IMAGES')
  const rapidPay = `${URL_STATICS_IMAGES}common/logos/rapidpay-by-santander.svg`

  const ctaFooterClassname = cx('mt-ModalTransactionDiscover-ctaFootnote', {
    'mt-ModalTransactionDiscover-ctaFootnote--centered': isFooterCentered
  })

  return (
    <div className={ctaFooterClassname}>
      <div className="mt-ModalTransactionDiscover-ctaFootnoteText">
        {i18n.t('VEHICLE_TRANSACTION.ONBOARDING_STEPS.PAYCAR_SERVICES_AND')}
      </div>
      <div className="mt-ModalTransactionDiscover-ctaFootnoteLogoWrapper">
        <div>
          <AtomImage src={rapidPay} alt="rapidpay logo" className="mt-ModalTransactionDiscover-ctaFootnoteLogo" />
        </div>
      </div>
    </div>
  )
}

CtaFootnoteSantander.displayName = 'CtaFootnoteSantander'
CtaFootnoteSantander.propTypes = {
  isFooterCentered: PropTypes.bool
}

CtaFootnoteSantanderDGT.displayName = 'CtaFootnoteSantanderDGT'
CtaFootnoteSantanderDGT.propTypes = {
  isFooterCentered: PropTypes.bool
}

CtaFootnoteRapidPayLogalty.displayName = 'CtaFootnoteRapidPayLogalty'
CtaFootnoteRapidPayLogalty.propTypes = {
  isFooterCentered: PropTypes.bool
}
